<template>
  <div class="wrapper wover">
  <div class="wrapp reports-body" id="mainpage">
    <div class="row col-12 pageHeader">
      <span class="col-12">Relatório de Acompanhamento de Mercado</span>
    </div>
    <!-- <div class="row col-9" style="color:red;"> -->
    <div class="row col-9">
      Esse relatório contempla enriquecimento de dados dos clientes,
      podendo conter pequenas diferenças em relação ao emplacamento de veículos novos,
      portando não deve ser considerado para fins de analise de marketshare
      <!--
      Devido a instabilidades nas fontes de dados oficiais estamos
      enfrentando um atraso na atualização dos dados, que deve ser
      normalizado dentro do mês de Janeiro
      -->
    </div>
    <div class="row col-12 text-right padlr0" style="text-align: right;">
      <span class="col-12 padlr0">Dados atualizados até: {{ lastUpdateData }} </span>
    </div>
    <div class="col-12 pageFilter">
      <div class="col-9">
        <ul>
          <li class="col-5 text-center">
            <span class="col-12 text-left" style="display: flex; padding: 0px;">
              <label
                class="col-6"
                style="margin: 0px; padding: 0px;"
                for="dateFrom"
              >
                Período: De
              </label>
              <label
                class="col-6"
                style="margin: 0px; padding: 0px;"
                for="dateTo"
              >
                Até
              </label>
            </span>
            <ul class="col-12 text-center">
              <li class="col-6" style="display: flex; padding: 0px;">
                <b-form-input
                  class="inputDate"
                  id="dateFrom"
                  type="date"
                  :min="minInitialDate"
                  v-model="dateFrom"
                  @change="mudouFrom"
                  required
                />
              </li>
              <li class="col-6" style="display: flex; padding: 0px;">
                <b-form-input
                  class="inputDate"
                  id="dateTo"
                  type="date"
                  :max="maxInitialDate"
                  v-model="dateTo"
                  @change="mudouTo"
                  required
                />
              </li>
            </ul>
          </li>
          <li class="col-3">
            <span>
              Segmento
            </span>
            <ul>
              <li style="display: flex; width: 100%;">
                <b-select
                  id="segmento"
                  class="form-control no-select-caret"
                  v-model="segmento"
                  :options="segmentoOptions"
                  @change="mudouSegmento"
                >
                </b-select>
              </li>
            </ul>
          </li>
          <li class="col-4">
            <span>
              Área Operacional
            </span>
            <ul>
              <li style="display: flex; width: 100%;">
                <b-select
                  id="areaOper"
                  class="form-control no-select-caret"
                  v-model="areaOper"
                  :options="areaOperOptions"
                  @change="mudouAreaOper"
                >
                </b-select>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="col-1 blwhite">
        <ul>
          <li class="col-12"
            @click="obtemDadosGic"
          >
            <span>Buscar</span>
            <i
              class="fas fa-search"
              style="font-size: 21px;cursor: pointer; padding-right: 5px;"
            />
          </li>
        </ul>
      </div>
      <div v-if="!disableExcelButton" class="col-1 blwhite">
        <ul>
          <li class="col-12"
            @click="geraExcel"
          >
            <span>Clientes</span>
            <i
              class="fas fa-file-excel"
              style="font-size: 21px;cursor: pointer; padding-right: 5px;"
            />
          </li>
        </ul>
      </div>
      <div v-else class="col-1 blwhite">
        <ul>
          <li class="col-12">
            <span>Clientes</span>
            <i
              class="fas fa-cog fa-spin"
              style="font-size: 21px;cursor: pointer; padding-right: 5px;"
            />
          </li>
        </ul>
      </div>
      <div v-if="!loadingPdf" class="col-1 blwhite">
        <ul>
          <li class="col-12"
            @click="exportPdf"
          >
            <span class="col-12">PDF</span>
            <i
              class="fas fa-file-pdf"
              style="font-size: 21px;cursor: pointer; padding-right: 10px;"
            />
          </li>
        </ul>
      </div>
      <div v-else class="col-1 blwhite">
        <ul>
          <li class="col-12">
            <i
              class="fas fa-cog fa-spin"
              style="font-size: 21px;cursor: pointer; padding-right: 10px;"
            />
            <span>PDF</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="row pageData">
      <div class="card col-12">
        <div class="text-right">
          <button
            class="btn pull-right"
            style="box-shadow: none;"
            @click="visible1 = !visible1"
          >
            <i class="fas fa-angle-right" v-if="!visible1"></i>
            <i v-else class="fas fa-angle-down"></i>
          </button>
        </div>
        <b-collapse v-model="visible1" class="col-12 mt-2">
          <div class="col-12" style="display: flex;">
            <div class="col-4">
              <div
                v-if="loadingChassis"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12 infocard chassicard" v-else>
                <h5 class="font-bold no-margins text-left pt-4">Chassis</h5>
                <div class="col-12 cardicon">
                  <i class="fas fa-truck text-center"></i>
                </div>
                <div class="col-12 cardnumber">
                  {{ gicDados.chassis }}
                </div>
                <div class="col-12 cardtext">
                  <span>Quantidade de Chassis</span>
                </div>
                <div class="col-12">
                  <span>no período {{ dateFromBR }} a {{ dateToBR }}</span>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div
                v-if="loadingClientes"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12 infocard clientecard" v-else>
                <h5 class="font-bold no-margins text-left pt-4">Clientes</h5>
                <div class="col-12 cardicon">
                  <i class="fas fa-users text-center"></i>
                </div>
                <div class="col-12 cardnumber">
                  {{ gicDados.clientes }}
                </div>
                <div class="col-12 cardtext">
                  <span>
                    {{ (gicDados.chassis / gicDados.clientes).toFixed(2) }}
                    chassis emplacados
                  </span>
                </div>
                <div class="col-12">
                  <span>por cliente</span>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div
                v-if="loadingPerfis"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12 infocard perfilcard" v-else>
                <h5 class="font-bold no-margins text-left pt-4">Perfil</h5>
                  <highcharts :options="perfilOptions"></highcharts>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="card col-12">
        <div class="text-right">
          <button
            class="btn pull-right"
            style="box-shadow: none;"
            @click="visible2 = !visible2"
          >
            <i class="fas fa-angle-right" v-if="!visible2"></i>
            <i v-else class="fas fa-angle-down"></i>
          </button>
        </div>
        <b-collapse v-model="visible2" class="col-12 mt-2">
          <div class="col-12" style="display: flex;">
            <div class="col-6">
              <div
                v-if="loadingMontadoras"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12" v-else>
                <h5 class="font-bold no-margins text-center pt-4">DISTRIBUIÇÃO POR MONTADORA</h5>
                  <highcharts :options="montadoraOptions"></highcharts>
              </div>
            </div>
            <div class="col-6">
              <div
                v-if="loadingSegmentos"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12" v-else>
                <h5 class="font-bold no-margins text-center pt-4">DISTRIBUIÇÃO POR SEGMENTO</h5>
                  <highcharts :options="segmentoChartOptions"></highcharts>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="card col-12">
        <div class="text-right">
          <button
            class="btn pull-right"
            style="box-shadow: none;"
            @click="visible3 = !visible3"
          >
            <i class="fas fa-angle-right" v-if="!visible3"></i>
            <i v-else class="fas fa-angle-down"></i>
          </button>
        </div>
        <b-collapse v-model="visible3" class="col-12 mt-2">
          <div class="col-12">
            <div
              v-if="loadingMedias"
              class="text-center"
              style="padding-top: 20px;"
            >
              <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
              ></b-spinner>
            </div>
            <div class="col-12" v-else>
              <h5 class="font-bold no-margins text-center pt-4">
                MÉDIA DE EMPLACAMENTO POR MONTADORA
              </h5>
              <highcharts :options="mediaMontadoraOptions"></highcharts>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="card col-12">
        <div class="text-right">
          <button
            class="btn pull-right"
            style="box-shadow: none;"
            @click="visible4 = !visible4"
          >
            <i class="fas fa-angle-right" v-if="!visible4"></i>
            <i v-else class="fas fa-angle-down"></i>
          </button>
        </div>
        <b-collapse v-model="visible4" class="col-12 mt-2">
          <div class="col-12" style="display: flex;">
            <div class="col-6">
              <div
                v-if="loadingModelo"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12" v-else>
                <h5 class="font-bold no-margins text-center pt-4">
                  TOP 10 EMPLACAMENTOS POR MODELO
                </h5>
                  <highcharts :options="top10ModeloOptions"></highcharts>
              </div>
            </div>
            <div class="col-6">
              <div
                v-if="loadingMunicipio"
                class="text-center"
                style="padding-top: 20px;"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
              </div>
              <div class="col-12" v-else>
                <h5 class="font-bold no-margins text-center pt-4">
                  TOP 10 EMPLACAMENTOS POR MUNICIPIO
                </h5>
                  <highcharts :options="top10MunicipioOptions"></highcharts>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="card col-12 bottom20">
        <div class="text-right">
          <button
            class="btn pull-right"
            style="box-shadow: none;"
            @click="visible5 = !visible5"
          >
            <i class="fas fa-angle-right" v-if="!visible5"></i>
            <i v-else class="fas fa-angle-down"></i>
          </button>
        </div>
        <b-collapse v-model="visible5" class="col-12 mt-2">
          <div class="col-12">
            <div
              v-if="loadingCompradores"
              class="text-center"
              style="padding-top: 20px;"
            >
              <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
              ></b-spinner>
            </div>
            <div class="col-12" v-else>
              <h5 class="font-bold no-margins text-center pt-4">
                PRINCIPAIS COMPRADORES POR MONTADORA
              </h5>
              <b-table :items="itemsCompradores" :fields="fieldsCompradores" id="tabcompradores" >
                <template v-slot:cell(VW)="row">
                  <div v-if="row.item.VW!==0" class="txt-fill"> {{ row.item.VW }}
                  </div>
                  <div v-else> {{ row.item.VW }}
                  </div>
                </template>
                <template v-slot:cell(MBENZ)="row">
                  <div v-if="row.item.MBENZ!==0" class="txt-fill"> {{ row.item.MBENZ }}
                  </div>
                  <div v-else> {{ row.item.MBENZ }}
                  </div>
                </template>
                <template v-slot:cell(FORD)="row">
                  <div v-if="row.item.FORD!==0" class="txt-fill"> {{ row.item.FORD }}
                  </div>
                  <div v-else> {{ row.item.FORD }}
                  </div>
                </template>
                <template v-slot:cell(VOLVO)="row">
                  <div v-if="row.item.VOLVO!==0" class="txt-fill"> {{ row.item.VOLVO }}
                  </div>
                  <div v-else> {{ row.item.VOLVO }}
                  </div>
                </template>
                <template v-slot:cell(IVECO)="row">
                  <div v-if="row.item.IVECO!==0" class="txt-fill"> {{ row.item.IVECO }}
                  </div>
                  <div v-else> {{ row.item.IVECO }}
                  </div>
                </template>
                <template v-slot:cell(SCANIA)="row">
                  <div v-if="row.item.SCANIA!==0" class="txt-fill"> {{ row.item.SCANIA }}
                  </div>
                  <div v-else> {{ row.item.SCANIA }}
                  </div>
                </template>
                <template v-slot:cell(DAF)="row">
                  <div v-if="row.item.DAF!==0" class="txt-fill"> {{ row.item.DAF }}
                  </div>
                  <div v-else> {{ row.item.DAF }}
                  </div>
                </template>
                <template v-slot:cell(RENAULT)="row">
                  <div v-if="row.item.RENAULT!==0" class="txt-fill"> {{ row.item.RENAULT }}
                  </div>
                  <div v-else> {{ row.item.RENAULT }}
                  </div>
                </template>
                <template v-slot:cell(FIAT)="row">
                  <div v-if="row.item.FIAT!==0" class="txt-fill"> {{ row.item.FIAT }}
                  </div>
                  <div v-else> {{ row.item.FIAT }}
                  </div>
                </template>
                <template v-slot:cell(PEUGEOT)="row">
                  <div v-if="row.item.PEUGEOT!==0" class="txt-fill"> {{ row.item.PEUGEOT }}
                  </div>
                  <div v-else> {{ row.item.PEUGEOT }}
                  </div>
                </template>
                <template v-slot:cell(CITROEN)="row">
                  <div v-if="row.item.CITROEN!==0" class="txt-fill"> {{ row.item.CITROEN }}
                  </div>
                  <div v-else> {{ row.item.CITROEN }}
                  </div>
                </template>
                <template v-slot:cell(AGRALE)="row">
                  <div v-if="row.item.AGRALE!==0" class="txt-fill"> {{ row.item.AGRALE }}
                  </div>
                  <div v-else> {{ row.item.AGRALE }}
                  </div>
                </template>
                <template v-slot:cell(INTER)="row">
                  <div v-if="row.item.INTER!==0" class="txt-fill"> {{ row.item.INTER }}
                  </div>
                  <div v-else> {{ row.item.INTER }}
                  </div>
                </template>
                <template v-slot:cell(TOTAL)="row">
                  <div v-if="row.item.TOTAL!==0" class="txt-fill"> {{ row.item.TOTAL }}
                  </div>
                  <div v-else> {{ row.item.TOTAL }}
                  </div>
                </template>
                <template v-slot:cell(OUTROS)="row">
                  <div v-if="row.item.OUTROS!==0" class="txt-fill"> {{ row.item.OUTROS }}
                  </div>
                  <div v-else> {{ row.item.OUTROS }}
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import JsPdf from 'jspdf';
import Html2canvas from 'html2canvas';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';
const graphColor = ['#95d9f0', '#5576a0', '#f17979', '#f0831d', '#ffdf87', '#bababa', '#dedede', 'black'];

export default {
  name: 'EnriquecimentoBaixarDados',
  components: {},
  data: () => ({
    user: null,
    userAuth: null,
    resposta: null,
    minInitialDate: '',
    maxInitialDate: '',
    dateFrom: null,
    dateTo: null,
    dateFromBR: null,
    dateToBR: null,
    segmento: null,
    areaOper: null,
    areaOperGic: [],
    segmentoList: [],
    userSegments: [],
    areaOperList: [],
    userAreaOper: [],
    marcaList: [],
    userMarcas: [],
    marcasGic: [],
    segmentoOptions: [],
    areaOperOptions: [],
    contractDealers: [],
    lastUpdateData: '',
    gicDados: {},
    visible1: true,
    visible2: true,
    visible3: true,
    visible4: true,
    visible5: true,
    loadingChassis: false,
    loadingClientes: false,
    loadingPerfis: false,
    loadingMontadoras: false,
    loadingSegmentos: false,
    loadingMedias: false,
    loadingModelo: false,
    loadingMunicipio: false,
    loadingCompradores: false,
    perfilOptions: {
      credits:{ enabled: false },
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        height: 200,
        marginTop: 0,
      },
      tooltip: {
        pointFormat: '{point.y} - {point.percentage:.1f}%',
      },
      plotOptions: {
        pie: {
          center: ["50%", "50%"],
          colors: graphColor,
          size: '70%',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name}<br /> {point.y} - {point.percentage:.1f}%',
            // format: '<div style="color:{point.color};text-align:center;font-size:7pt;">{point.name} <br /> {point.y} | {point.percentage:.1f}%</div>',
            align: 'center',
            connectorWidth: 0,
            distance: 20,
          },
          showInLegend: false,
        }
      },
      title: {
        text: null,
      },
      series: [{
        name: 'Perfis',
        colorByPoint: true,
        data: [],
      }],
    },
    montadoraOptions: {
      credits:{ enabled: false },
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        width: 700,
        height: 350,
        margin: 20,
      },
      tooltip: {
        pointFormat: '{point.y} - {point.percentage:.1f}%',
      },
      plotOptions: {
        pie: {
          colors: graphColor,
          size: '100%',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            // format: '{point.name}<br /> {point.y} - {point.percentage:.1f}%',
            format: '<div style="color:{point.color};text-align:center;font-size:7pt;">{point.name} <br /> {point.y} | {point.percentage:.1f}%</div>',
            align: 'center',
            connectorWidth: 0,
          },
          showInLegend: false,
        }
      },
      title: {
        text: null,
      },
      series: [{
        name: 'Montadoras',
        colorByPoint: true,
        data: [],
      }],
    },
    segmentoChartOptions: {
      credits:{ enabled: false },
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        width: 700,
        height: 350,
        margin: 20,
      },
      tooltip: {
        pointFormat: '{point.y} - {point.percentage:.1f}%',
      },
      plotOptions: {
        pie: {
          colors: graphColor,
          size: '100%',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            // format: '{point.name}<br /> {point.y} - {point.percentage:.1f}%',
            format: '<div style="color:{point.color};text-align:center;font-size:7pt;">{point.name} <br /> {point.y} | {point.percentage:.1f}%</div>',
            align: 'center',
            connectorWidth: 0,
          },
          showInLegend: false,
        }
      },
      title: {
        text: null,
      },
      series: [{
        name: 'Segmentos',
        colorByPoint: true,
        data: [],
      }],
    },
    mediaMontadoraOptions: {
      credits:{ enabled: false },
      chart: {
        // type: 'column',
        backgroundColor: 'transparent',
      },
      legend:{ enabled:false },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        series: {
          pointWidth: 35,
          pointPadding: 0,
        }
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: [],
      },
      yAxis: [{
          title: {
            text: 'Quantidade',
          },
        }, {
          title: {
            text: '',
        }}, {
          min: 1,
          title: {
            text: 'Média',
        },
        opposite: true,
      }],
      series: [{
          name: 'Chassis',
          yAxis: 1,
          type: 'column',
          data: [],
          dataLabels: {
            enabled: true,
          },
        }, {
          yAxis: 1,
          name: 'Clientes',
          type: 'column',
          data: [],
          dataLabels: {
            enabled: true,
          },
        }, {
          name: 'Média',
          yAxis: 2,
          type: 'spline',
          color: '#FF0000',
          data: [],
          dataLabels: {
            enabled: true,
          },
        }],
    },
    top10ModeloOptions: {
      credits:{ enabled: false },
      chart: {
        type: 'bar',
        backgroundColor: 'transparent',
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        series: {
          showInLegend: false,
          pointWidth: 15,
          pointPadding: 0,
        }
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: [],
      },
      yAxis: {
        title: {
          text: 'Quantidade'
        }
      },
      series: [{
        name: 'Top10Modelo',
        dataLabels: {
          enabled: true,
          align: 'right',
          format: '{point.y}'
        },
        data: []
      }],
    },
    top10MunicipioOptions: {
      credits:{ enabled: false },
      chart: {
        type: 'bar',
        backgroundColor: 'transparent',
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        series: {
          showInLegend: false,
          pointWidth: 15,
          pointPadding: 0,
        }
      },
      title: {
        text: null,
      },
      xAxis: {
        crosshair: true
      },
      yAxis: {
        title: {
          text: 'Quantidade'
        }
      },
      series: [{
        name: 'Top10Municipio',
        dataLabels: {
          enabled: true,
          align: 'right',
          format: '{point.y}'
        },
        data: []
      }],
    },
    itemsCompradores: [],
    fieldsCompradores: [],
    excelFilename: 'relatorio_enriquecimento',
    disableExcelButton: false,
    loadingPdf: false,
  }),
  watch: {},
  computed: {},
  methods: {
    async getUser() {
      try {
        const { data } = await axios.get(`${url}/user/${this.userAuth.id}`, {});
        const contractDealers = [];
        this.user = data;
        // filtra dealers, obtem apenas os que tem contrato
        for (let i = 0; i < this.user.dealers.length; i += 1) {
          for (let j = 0; j < this.contractDealers.length; j += 1) {
            if (this.user.dealers[i].account === this.contractDealers[j].account) {
              this.user.dealers[i].initDate = this.contractDealers[j].data_contrato;
              contractDealers.push(this.user.dealers[i]);
              break;
            }
          }
        }
        this.user.dealers = contractDealers;
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },
    async getContractDealers() {
      this.contractDealers = [];
      // obtem quais os dealers com contrato para obter as áreas operacionais
      const { data } = await axios.get(`${url}/dealers-enriquecimento`);
      this.contractDealers = data;

    },
    formatDate(data){
      let dia  = data.getDate().toString();
      let diaF = (dia.length == 1) ? '0'+dia : dia;
      let mes  = (data.getMonth()+1).toString();
      let mesF = (mes.length == 1) ? '0'+mes : mes;
      let anoF = data.getFullYear();
      return anoF+"-"+mesF+"-"+diaF;
    },
    formatDateBR(data){
      let dia  = data.getDate().toString();
      let diaF = (dia.length == 1) ? '0'+dia : dia;
      let mes  = (data.getMonth()+1).toString();
      let mesF = (mes.length == 1) ? '0'+mes : mes;
      let anoF = data.getFullYear();
      return diaF+"/"+mesF+"/"+anoF;
    },
    mudouFrom() {
      this.dateFromBR = this.dateFrom.substr(8, 2) + '/' + this.dateFrom.substr(5, 2) + '/' + this.dateFrom.substr(0, 4);
      // this.obtemDadosGic();
    },
    mudouTo() {
      this.dateToBR = this.dateTo.substr(8, 2) + '/' + this.dateTo.substr(5, 2) + '/' + this.dateTo.substr(0, 4);
      // this.obtemDadosGic();
    },
    mudouSegmento() {
      // this.obtemDadosGic();
    },
    mudouAreaOper() {
      const myAreaOper = [];
      if (this.areaOper === 'TODOS') {
        for (let i = 0; i < this.areaOperOptions.length; i += 1) {
          if (this.areaOperOptions[i].value !== 'TODOS') {
            myAreaOper.push(this.areaOperOptions[i].value);
          }
        }
      } else {
        myAreaOper.push(this.areaOper);
      }
      this.areaOperGic = myAreaOper;
      // this.obtemDadosGic();
    },
    getSegmentName(id) {
      for (let i = 0; i < this.segmentoList.length; i += 1) {
        // eslint-disable-next-line eqeqeq
        if (this.segmentoList[i].segmento == id) {
          return this.segmentoList[i].descricao;
        }
      }
      return null;
    },
    async getUserSegments() {
      // carrega segmentos do usuario
      const { data } = await axios.get(`${url}/segments/${this.userAuth.id}`);
      this.userSegments = data;
    },
    async getUserMarcas() {
      // carrega marcas do usuario
      const { data } = await axios.get(`${url}/marcas/${this.userAuth.id}`);
      this.userMarcas = data;
    },
    async carregaSegmentos() {
      try {
        // carrega todos os segmentos
        const { data } = await axios.get(`${url}/dados/segmentos`);
        this.segmentoList = data;

        await this.getUserSegments();

        // monta lista de segmentos
        // se usuario = master, nao tem restricao de segmento
        this.segmentoOptions = [];
        if (!(this.userAuth.type === 'master')) {
          for (let i = 0; i < this.userSegments.length; i += 1) {
            this.segmentoOptions.push({
              value: this.userSegments[i].segmentId,
              // value: this.segmentoList[i].descricao,
              text: await this.getSegmentName(this.userSegments[i].segmentId),
            });
          }          
        } else {
          for (let i = 0; i < this.segmentoList.length; i++) {
            this.segmentoOptions.push({
              value: this.segmentoList[i].segmento,
              // value: this.segmentoList[i].descricao,
              text: this.segmentoList[i].descricao,
            });
          }
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async carregaAreas() {
      try {
        const { data } = await axios.get(`${url}/dados/areas`);
        this.areaOperList = data;
        // ordena areas operacionais por descricao
        this.areaOperList.sort(function(a,b) {
            return a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0;
        });
        // console.log('areasOperacionais', this.areaOperList);
        // ordena lista de areas operacionais de usuario por nome
        this.user.dealers.sort(function(a,b) {
            return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });
        // se for dealer, tem restricao de area
        this.areaOperOptions = [];
        this.areaOperOptions.push({value: 'TODOS', text: 'TODOS'});
        if (this.userAuth.type === 'dealer') {
          for (let i = 0; i < this.user.dealers.length; i += 1) {
            for (let j = 0; j < this.areaOperList.length; j += 1) {
              if (this.user.dealers[i].operational_area === this.areaOperList[j].areaOperacional) {
                let achou = false;
                for (let k = 0; k < this.areaOperOptions.length; k +=1) {
                  if (this.areaOperOptions[k].value === this.areaOperList[j].areaOperacional) {
                    achou = true;
                    break;
                  }
                }
                if (!achou) {
                  this.areaOperOptions.push({
                    value: this.areaOperList[j].areaOperacional,
                    text: this.areaOperList[j].descricao,
                  });
                }
              }
            }
          }
        } else {
          for (let i = 0; i < this.areaOperList.length; i++) {
            this.areaOperOptions.push({
              value: this.areaOperList[i].areaOperacional,
              text: this.areaOperList[i].descricao,
            });
          }
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async carregaMarcas() {
      try {
        // carrega todas as marcas
        const { data } = await axios.get(`${url}/dados/marcas`);
        this.marcaList = data;
        await this.getUserMarcas();
        // monta lista de marcas
        // se usuario = master, nao tem restricao de marcas
        this.marcasGic = [];
        if (this.userAuth.type === 'master') {
          for (let i = 0; i < this.marcaList.length; i++) {
            this.marcasGic.push(this.marcaList[i].marca);
          }
        } else {
          for (let i = 0; i < this.userMarcas.length; i++) {
            this.marcasGic.push(this.userMarcas[i].marcaId);
          }
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemLastUpdate() {
      try {
        const { data } = await axios.get(`${url}/dados/lastupdate`);
        this.lastUpdateData = data.lastdate;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemGicGeral()  {
      try {
        const { data } = await axios.get(`${url}/dados/gic`,{
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            segmento: this.segmento,
            areaOper: this.areaOperGic,
            tipo: 'geral',
            // marca: this.marcasGic,
          }
        });
        this.gicDados.perfis = data.perfis;
        this.gicDados.clientes = data.clientes;
        this.gicDados.chassis = data.chassis;
        this.gicDados.montadoras = data.montadoras;
        this.gicDados.segmentos = data.segmentos;
        // perfil
        this.perfilOptions.series[0].data = [];
        this.perfilOptions.series[0].data.push({
            name: 'PF',
            y: parseInt(this.gicDados.perfis[0].FISICA),
        });
        this.perfilOptions.series[0].data.push({
            name: 'PJ',
            y: parseInt(this.gicDados.perfis[0].JURIDICA),
        });

        // montadoras
        this.montadoraOptions.series[0].data = [];
        let others = 0;
        const othersQty = this.gicDados.chassis * 0.05;
        for (let i = 0; i < this.gicDados.montadoras.length; i++) {
          if (this.gicDados.montadoras[i].qtd >= othersQty) {
            this.montadoraOptions.series[0].data.push({
              name: this.gicDados.montadoras[i].descricao,
              y: this.gicDados.montadoras[i].qtd,
            });
          } else {
            others = others + this.gicDados.montadoras[i].qtd;
          }
        }
        if (others > 0) {
            this.montadoraOptions.series[0].data.push({
              name: 'Other',
              y: others,
            });          
        }
        // segmentos
        this.segmentoChartOptions.series[0].data = [];
        for (let i = 0; i < this.gicDados.segmentos.length; i++) {
          this.segmentoChartOptions.series[0].data.push({
             name: this.gicDados.segmentos[i].descricao,
             y: this.gicDados.segmentos[i].qtd,
          });
        }
      this.loadingChassis = false;
      this.loadingClientes = false;
      this.loadingPerfis = false;
      this.loadingMontadoras = false;
      this.loadingSegmentos = false;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemGicMedias() {
      try {
        const { data } = await axios.get(`${url}/dados/gic`,{
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            segmento: this.segmento,
            areaOper: this.areaOperGic,
            tipo: 'medias',
            // marca: this.marcasGic,
          }
        });
        this.gicDados.mediasEmplacamentos = data.mediasEmplacamentos;
        // medias emplacamentos montadoras
        this.mediaMontadoraOptions.series[0].data = [];
        this.mediaMontadoraOptions.series[1].data = [];
        this.mediaMontadoraOptions.series[2].data = [];
        this.mediaMontadoraOptions.xAxis.categories = [];
        let str;
        let strAux;
        for (let i = 0; i < this.gicDados.mediasEmplacamentos.length; i++) {
          this.mediaMontadoraOptions.xAxis.categories.push(this.gicDados.mediasEmplacamentos[i].marca);
          this.mediaMontadoraOptions.series[0].data.push(this.gicDados.mediasEmplacamentos[i].chassis);
          this.mediaMontadoraOptions.series[1].data.push(this.gicDados.mediasEmplacamentos[i].clientes);
          this.mediaMontadoraOptions.series[2].data.push(
            parseFloat((this.gicDados.mediasEmplacamentos[i].chassis / this.gicDados.mediasEmplacamentos[i].clientes
          ).toFixed(2)));
        }
        this.loadingMedias = false;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemGicTopModelo() {
      try {
        const { data } = await axios.get(`${url}/dados/gic`,{
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            segmento: this.segmento,
            areaOper: this.areaOperGic,
            tipo: 'modelo',
            // marca: this.marcasGic,
          }
        });
        this.gicDados.top10Modelo = data.top10Modelo;
        // top 10 modelo
        this.top10ModeloOptions.series[0].data = [];
        this.top10ModeloOptions.xAxis.categories = [];
        for (let i = 0; i < this.gicDados.top10Modelo.length; i++) {
          this.top10ModeloOptions.xAxis.categories.push(
            this.gicDados.top10Modelo[i].DESCRICAO
          );
          this.top10ModeloOptions.series[0].data.push(
            this.gicDados.top10Modelo[i].chassis
          );
        }
        this.loadingModelo = false;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemGicTopMunicipio() {
      try {
        const { data } = await axios.get(`${url}/dados/gic`,{
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            segmento: this.segmento,
            areaOper: this.areaOperGic,
            tipo: 'municipio',
            // marca: this.marcasGic,
          }
        });
        this.gicDados.top10Municipio = data.top10Municipio;
        // top 10 municipio
        this.top10MunicipioOptions.series[0].data = [];
        this.top10MunicipioOptions.xAxis.categories = [];
        for (let i = 0; i < this.gicDados.top10Municipio.length; i++) {
          this.top10MunicipioOptions.xAxis.categories.push(
            this.gicDados.top10Municipio[i].NOME
          );
          this.top10MunicipioOptions.series[0].data.push(
            this.gicDados.top10Municipio[i].chassis
          );
        }
        this.loadingMunicipio = false;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemGicTopCompradores() {
      try {
        const { data } = await axios.get(`${url}/dados/gic`,{
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            segmento: this.segmento,
            areaOper: this.areaOperGic,
            tipo: 'compradores',
            // marca: this.marcasGic,
          }
        });
        this.gicDados.top10Compradores = data.top10Compradores;
        // top 10 compradores
        this.itemsCompradores = [];
        this.fieldsCompradores = [];
        if (this.gicDados.top10Compradores.length > 0) {
          let i = 0;
          for (var property in this.gicDados.top10Compradores[0]){
            const prop = property; 
            this.fieldsCompradores.push({
              key: prop,
              label: prop,
              class: i == 0 ? 'text-left max15' : 'text-center max9',
            });
            i = i + 1;
          }
        }
        for (let i = 0; i < this.gicDados.top10Compradores.length; i++) {
          const myItem = {};
          for (var property in this.gicDados.top10Compradores[i]){
            myItem[property] = this.gicDados.top10Compradores[i][property];
          }
          this.itemsCompradores.push(myItem);
        }
        this.loadingCompradores = false;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },

    async obtemDadosGic() {
      this.loadingChassis = true;
      this.loadingClientes = true;
      this.loadingPerfis = true;
      this.loadingMontadoras = true;
      this.loadingSegmentos = true;
      this.loadingMedias = true;
      this.loadingModelo = true;
      this.loadingMunicipio = true;
      this.loadingCompradores = true;
      if (this.segmentoOptions.length === 0
        || this.areaOperGic.length === 0) {
        // || this.marcasGic.length === 0) {
        // this.$swal('Falhou!', 'Você não possui associação de Segmento, Área Operacional ou Marca.', 'error');
        this.$swal('Falhou!', 'Você não possui associação de Segmento ou Área Operacional', 'error');
        return;
      }
      this.gicDados = {};
      this.obtemGicGeral();
      this.obtemGicMedias();
      this.obtemGicTopModelo();
      this.obtemGicTopMunicipio();
      this.obtemGicTopCompradores();
    },

    async getContractInitDate() {
      if (this.user.dealers.length > 0) {
        const myUserDealers = JSON.parse(JSON.stringify(this.user.dealers));
        myUserDealers.sort(function(a,b) {
          return a.initDate < b.initDate ? -1 : a.initDate > b.initDate ? 1 : 0;
        });
        return myUserDealers[0].initDate;
      }
      return null;
    },

    async obtemDadosExcel() {
      try {
        const { data } = await axios.get(`${url}/dados/excel`,{
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            segmento: this.segmento,
            areaOper: this.areaOperGic,
            marca: this.marcasGic,
          }
        });
        const filename = data.filename;
        window.open(`${url}/public/${filename}`);
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async geraExcel(){
      if (this.segmentoOptions.length === 0
        || this.areaOperGic.length === 0
        || this.marcasGic.length === 0) {
        this.$swal('Falhou!', 'Você não possui associação de Segmento, Área Operacional ou Marca.', 'error');
        return;
      }
      this.disableExcelButton = true;
      await this.obtemDadosExcel();
      this.disableExcelButton = false;
    },

    async geraPdf() {
      setTimeout(() => {
        const data = document.getElementById('mainpage');
        Html2canvas(data, {
          allowTaint: true,
          scale: 2,
        }).then((canvas) => {
          const contentWidth = canvas.width;
          const contentHeight = canvas.height;
          const pageData = canvas.toDataURL('image/jpeg', 1.0);
          const pdf = new JsPdf('', 'pt', [contentWidth+100, contentHeight+100]);
          pdf.addImage(pageData, 'jpeg', 50, 50, contentWidth, contentHeight);
          pdf.save('enriquecimento.pdf');
        });
      }, 100);
    },

    async exportPdf() {
      this.loadingPdf = true;
      await this.geraPdf();
      this.loadingPdf = false;
    },

  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
  async mounted() {
    await this.getContractDealers();
    await this.getUser();
    const contractInitDate = await this.getContractInitDate();
    await this.obtemLastUpdate();
    this.maxInitialDate = this.lastUpdateData.substr(6,4)+'-'+this.lastUpdateData.substr(3,2)+'-'+this.lastUpdateData.substr(0,2);

    const today = new Date();
    let initDate = today;
    if (contractInitDate) {
      initDate = new Date(contractInitDate);
      this.minInitialDate = contractInitDate.toLocaleString("pt-BR", {timeZone: "America/Sao_Paulo"});
    } else {
      this.minInitialDate = "2020-01-01";
    }
    let firstDay;
    if (initDate.getTime() > today.getTime()) {
      firstDay = initDate;
      this.dateTo = this.minInitialDate;
      this.dateToBR = this.minInitialDate.substr(8,2)+'/'+this.minInitialDate.substr(5,2)+'/'+this.minInitialDate.substr(0,4);
      this.dateFrom = this.minInitialDate;
      this.dateFromBR = this.dateToBR;
    } else {
      firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      this.dateTo = this.maxInitialDate;
      this.dateToBR = this.maxInitialDate.substr(8,2)+'/'+this.maxInitialDate.substr(5,2)+'/'+this.maxInitialDate.substr(0,4);
      this.dateFrom = this.formatDate(firstDay);
      this.dateFromBR = this.formatDateBR(firstDay);
    }
    await this.carregaSegmentos();
    await this.carregaMarcas();
    await this.carregaAreas();
    if (this.userAuth.type === 'master') {
      this.segmento = 3;      // '1.0-CAMINHOES';    // Caminhoes
    } else if (this.userSegments) {
      this.segmento = this.userSegments[0].segmentId;
    }
    this.areaOper = 'TODOS';    // Todos
    await this.mudouAreaOper();
    await this.obtemDadosGic();
  },
};
</script>

<style lang="scss" scoped>

.wrapp {
  padding: 16px;
  // max-height: calc(100vh - 72px);
  background-color: white;
  overflow: auto;
}
.pageHeader {
  color: darkgray;
  text-align: center;
  font-size: 26px;
}
.pageFilter {
  background-color: #fdedde;
  color: #f38419;
  padding-top: 10px;
  display: flex;
}
.pageData {
  color: darkgray;
}
.blwhite {
  border-left: solid white 2px;
  // padding-top: 25px;;
}
ul {
  display: flex;
  padding-left: 0px;
}
li {
  list-style-type: none;
  text-align: center;
}
.inputDate {
  max-width: 200px;
  max-height: 35px;
  margin: 0px 2px;
  padding: 2px;
}
#segmento {
  max-height: 35px;
  padding: 0px 10px;
  width: 100%;
  padding-left: 5px;
}
#areaOper {
  max-height: 35px;
  padding: 0px 10px;
  width: 100%;
  padding-left: 5px;
}
.padlr0 {
  padding-left: 0px;
  padding-right: 0px;
}
.infocard {
  height: 250px;
  border-radius: 10px;
  color: white;
  text-align: center;;
}
.chassicard {
  background-color: #5576a0;
}
.clientecard {
  background-color: #60b6e2;
}
.perfilcard {
  background-color: #afbed0;
}
.cardicon{
  font-size: 50px;
}
.cardnumber {
  font-size: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.cardtext {
  font-size: 16px;
}
.dflex {
  display: flex;
}
.thcolor {
    background-color: #5576a0;
    color: #fff;
}
#excelButton button {
  color: #f38419;
  background: transparent;
  border: none;
}
.bottom20 {
  padding-bottom: 20px;
}
.wover {
  height: calc(100vh - 72px);
  overflow: auto;
}
#mainpage {
  min-height: 1200px;
}
</style>
<style>
.hidden_header {
  display: none;
}
#tabcompradores {
  color: unset;
}
#tabcompradores th {
  background-color: inherit;
  color: inherit;
}
.txt-fill {
  color: #5576a0;
  font-weight: bold;
}
.max15 {
  width: 15%;
}
.max9 {
  width: 9%;
}
select.custom-select.no-select-caret {
  background-image: none !important;
}</style>
